
import mqtt from "mqtt";
import config from '@/service/config.js'
import {jointRotateConfig, getSpeedValueByIndex} from "./joint-rotate-config";
window.__nuwaMqttConstructor = mqtt;
export default function initNuwaSimulatorScript () {
  const Blockly = window.Blockly;
  const nuwa_func_start = "NUWA_FUNC_START";
  const nuwa_func_end = "NUWA_FUNC_END";
  const fun_arg_marker = "NUWA_FUNC_ARG_MARKER";
  const startFuncBlocksType = ["start_start","start_when_v2", "procedures_defnoreturn", "procedures_defreturn", "mqtt_connect", "aiot_connect", "start_when_recognize"];
  const singleApis = [
    "NuwaMotion",
    "NuwaPlayVideo",
    "NuwaEmotionVideo",
    "NuwaPlayYoutube",
    "NuwaPlayPicture",
    "NuwaPlayImage",
    "NuwaFaceImage",
    "NuwaRole",
    "NuwaPlayContent",
    "NuwaResetRobot"
  ];
  function hasStartBlock(block){
    block = block.getRootBlock();
    if(startFuncBlocksType.includes(block.type)){
      return !block.disabled && !block.getInheritedDisabled();
    }
    return false;
  }
  function markRunnerId(){
    return '"NUWA_RUNNER_ID_MARKER"'
  }
  //开始
  Blockly.JavaScript['start_start'] = function() {
    var code = 'await NuwaStart("'+ this.id + '",' + markRunnerId() + ');\n';
    return code;
  };

  //当机器人被。。。开始
  Blockly.JavaScript['start_when_v2'] = function(block) {
    var value_controll_id = block.getFieldValue('input1') || "TouchAction,0";
    var code = "";
    code += 'await NuwaStartWhen("' + value_controll_id + '","' + this.id + '",' + markRunnerId() + ');\n';
    return code;
  };

  //跳到开始
  Blockly.JavaScript['start_goto_start'] = function() {
    var code = "";
    code +='await showWorkspaceCode(' + markRunnerId()+');\n';
    return code;
  };
  //結束程式
  Blockly.JavaScript['stop_excute'] = function() {
    var code ='await NuwaStopExcute(NsUyWnAc, "'+ this.id + '",' + markRunnerId() + ');\n';
    return code;
  };
  //重置機器人
  Blockly.JavaScript['reset_robot'] = function(block) {
    var input1 = block.getFieldValue("input1") || 0;
    var code ='await NuwaResetRobot(' + input1 + ', NsUyWnAc, "'+ this.id + '",' + markRunnerId() + ');\n';
    return code;
  };
  //等待机器人
  Blockly.JavaScript['control_wait_for'] = function(block) {
    var value_controll_id = block.getFieldValue('input1') || "TouchAction,0";
    var code = 'await NuwaWaitFor("' + value_controll_id + '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  Blockly.JavaScript['nuwa_control_hear_something'] = function(block) {
    var input1 = Blockly.JavaScript.variableDB_.getName(block.getFieldValue('input1'), Blockly.Variables.NAME_TYPE);
    // TODO: Assemble JavaScript into code variable.
    var code = 'await NuwaWaitHearSomething(' + nuwa_func_start + "message" + fun_arg_marker + input1 + ' = message;\n' + nuwa_func_end + ', NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //等待机器人n秒
  Blockly.JavaScript['control_delay'] = function(block) {
    var number_time = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaDelay("' + number_time + '", NsUyWnAc, "'+ this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //如果机器人。。。。
  Blockly.JavaScript['control_if'] = function(block) {
    var id = this.id;
    var value_condition = block.getFieldValue('input1') || "TouchAction,0";
    var duration = block.getFieldValue('input2') || 8;
    var statements_todo = Blockly.JavaScript.statementToCode(block, 'do1') || '';
    if(!statements_todo){
      return "";
    }
    var code = 'await NuwaIfBlock("' + value_condition + '", ' + duration + ', async ' + nuwa_func_start + statements_todo + nuwa_func_end + ', NsUyWnAc, "' + id +'", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //如果机器人。。。。否则
  Blockly.JavaScript['control_ifElse'] = function(block) {
    var id = this.id;
    var value_condition = block.getFieldValue('input1') || "TouchAction,0";
    var duration = block.getFieldValue('input2') || 8;
    var statements_todo1 = Blockly.JavaScript.statementToCode(block, 'do1') || '';
    var statements_todo2 = Blockly.JavaScript.statementToCode(block, 'do2') || '';
    if(!statements_todo1 && !statements_todo2){
      return "";
    }
    var code = 'await NuwaIfElseBlock("' + value_condition + '",' + duration + ', async ' + nuwa_func_start + statements_todo1 + nuwa_func_end + ', async ' + nuwa_func_start + statements_todo2 + nuwa_func_end + ', NsUyWnAc, "' + id +'", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };
  //重复执行
  Blockly.JavaScript['control_repeat_times'] = function(block){
    var id = this.id;
    var va3 = block.getFieldValue('input1');
    var statements_2 = Blockly.JavaScript.statementToCode(block, 'input2') || '';
    if(!statements_2){
      return "";
    }
    statements_2 += 'await NuwaDelay("0.3", NsUyWnAc, "end-delay", NpUaWrAallel_block_id);\n';
    var code = 'await NuwaRepeat(' + va3 + ', async ' + nuwa_func_start + statements_2 + nuwa_func_end + ', NsUyWnAc, "' + id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  }
  //永久重复
  Blockly.JavaScript["control_repeat_forever"] = function(block) {
    var todo = Blockly.JavaScript.statementToCode(block, "input2") || "";
    if(!todo){
      return "";
    }
    todo += 'await NuwaDelay("0.3", NsUyWnAc, "end-delay", NpUaWrAallel_block_id);\n';
    var code = 'await NuwaForever(async ' + nuwa_func_start + todo + nuwa_func_end + ', NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };
  //同时执行
  Blockly.JavaScript['control_parallel'] = function(block) {
    var statements_do = Blockly.JavaScript.statementToCode(block, 'do1');
    if(!statements_do){
      return "";
    }
    statements_do = statements_do.replace(/(\u00A0|\u2028|\u2029|\uFEFF)/gm, "");
    var id = this.id;
    var reg1 = new RegExp(nuwa_func_start + "((?!(" + nuwa_func_start + "|" + nuwa_func_end + "))(.|\n))*?" + nuwa_func_end, "g");
    var matches = statements_do.match(reg1);
    var count = 0;
    var obj = {};
    while(matches){
      matches.forEach(function(item){
        var key = "nuwa_matches_" + count;
        obj[key] = item;
        statements_do = statements_do.replace(item,key);
        count++;
      });
      matches = statements_do.match(reg1);
    }
    var nuwaBlockReg = /await ([\w\_]+\(.*?\));\n*/g;
    var singleApiReg = new RegExp(singleApis.join("|"));
    var nuwaBlockMatches = statements_do.match(nuwaBlockReg) || [];
    var removeSingleApis = [],hasSingleApi,paralleBlocks = [];
    for(let i = nuwaBlockMatches.length - 1;i >= 0;i--){
      var isSingleApi = singleApiReg.test(nuwaBlockMatches[i]);
      var isParalleBlock = /NuwaParallelExecute/.test(nuwaBlockMatches[i]);
      if(isSingleApi){
        if(hasSingleApi){
          removeSingleApis.push(nuwaBlockMatches[i]);
        } else {
          hasSingleApi = true;
        }
      } else if(isParalleBlock){
        paralleBlocks.push(nuwaBlockMatches[i]);
      }
    }
    removeSingleApis.forEach(item => {
      statements_do = statements_do.replace(item, "");
    });
    paralleBlocks.forEach(item => {
      statements_do = statements_do.replace(item, "");
    });
    paralleBlocks.forEach(item => {
      statements_do += item;
    });
    statements_do = statements_do.replace(nuwaBlockReg,"paralleExcutes.push($1);\n");
    var reg2 = /nuwa_matches_\d+/g;
    var matches2 = statements_do.match(reg2);
    while(matches2){
      matches2.forEach(function(item){
        statements_do = statements_do.replace(item, obj[item]);
      });
      matches2 = statements_do.match(reg2);
    }
    var code = "";
    statements_do = "let paralleExcutes = [];\n" + statements_do;
    statements_do += "return await Promise.all(paralleExcutes);\n";
    code += 'await NuwaParallelExecute( "start" ,"' + id +'",NpUaWrAallel_block_id,' + markRunnerId() + ', async ' + nuwa_func_start + statements_do + nuwa_func_end + ');\n' ;
    return code;
  };

  function getJointRotateCode(arg0, apiName, block){
    return 'await ' + apiName + '(' + arg0 + ', NsUyWnAc, "'+ block.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
  }

  // 肢体控制
  Blockly.JavaScript['nuwa_rotate_joint'] = function(block) {
    var input1 = block.getFieldValue('input1');//關節ID
    var input2 = block.getFieldValue('input2');//速度
    var input3 = Blockly.JavaScript.valueToCode(block, 'input3', Blockly.JavaScript.ORDER_NONE) || 0;//角度或者距離（cm）
    var jointConfig = jointRotateConfig.find(item => item.key === input1);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(input1, input2);
    input3 = jointConfig.fixInputValue(input3);
    var code = '"';
    code += (input1 + "," + input3 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };
  
  //角度
  Blockly.JavaScript['nuwa_angle'] = function(block) {
    var input1 = block.getFieldValue('input1') || 0;
    var code = input1;
    return [code, Blockly.JavaScript.ORDER_NONE];
  };

  //机器人旋转
  Blockly.JavaScript['drive_turn_v1'] = function(block) {
    var input1 = block.getFieldValue('input1');
    var input2 = block.getFieldValue('input2');
    var input3 = block.getFieldValue('input3');
    var jointConfig = jointRotateConfig.find(item => item.key === input1);
    if(!jointConfig){
      return "";
    }
    input3 = jointConfig.fixInputValue(input3);
    input2 = getSpeedValueByIndex(input1, input2);
    
    var code = '"';
    code += (input1 + "," + input3 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };
  //前后移动
  Blockly.JavaScript['drive_ward_v1'] = function(block) {
    var input1 = block.getFieldValue('input1');
    var input2 = block.getFieldValue('input2');
    var input3 = block.getFieldValue('input3');
    var jointConfig = jointRotateConfig.find(item => item.key === input1);
    if(!jointConfig){
      return "";
    }
    input3 = jointConfig.fixInputValue(input3);
    
    var code = '"';
    code += (input1 + "," + input3 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };
  
  // 头部上下
  Blockly.JavaScript['body_head_sagittal_new'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };
  // 头部左右
  Blockly.JavaScript['body_head_horizontal_new'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };

  // 左肩内转
  Blockly.JavaScript['body_shoulder_left_horizontal'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };

  //左肩上抬
  Blockly.JavaScript['body_shoulder_left_sagittal'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };

  // 左手臂侧抬
  Blockly.JavaScript['body_shoulder_left_frontal'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };
  // 左手肘上抬
  Blockly.JavaScript['body_elbow_left_sagittal'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };

  // 右肩侧转
  Blockly.JavaScript['body_shoulder_right_horizontal'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };

  // 右肩上抬
  Blockly.JavaScript['body_shoulder_right_sagittal'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };

  // 右手臂侧抬
  Blockly.JavaScript['body_shoulder_right_frontal'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };

  // 右手肘上抬
  Blockly.JavaScript['body_elbow_right_sagittal'] = function(block) {
    var input1 = block.getFieldValue('input1') || block.getField("input1").preValue + 0;
    var input2 = block.getFieldValue('input2');
    var jointId = input1.split(",").slice(0,2).join(",");
    var jointConfig = jointRotateConfig.find(item => item.key === jointId);
    if(!jointConfig){
      return "";
    }
    input2 = getSpeedValueByIndex(jointId, input2);
    var code = '"';
    code += (input1 + "," + input2);
    code += '"';
    code = getJointRotateCode(code, jointConfig.apiName, block);
    return code;
  };

  //全身发光
  Blockly.JavaScript['light_all'] = function(block) {
    var value_color = block.getFieldValue("input1") || "#ff0000";
    var code = "";
    code += 'await NuwaLight(0 , ' + new Boolean(true) + ' , ' + new Number(255) +  ' , "' + value_color +  '", NsUyWnAc, "'+ this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //头部发光
  Blockly.JavaScript['light_head'] = function(block) {
    var value_color = block.getFieldValue("input1") || "#ff0000";
    var code = "";
    code += 'await NuwaLight(1 , ' + new Boolean(true) + ' , ' + new Number(255) +  ' , "' + value_color +  '", NsUyWnAc, "'+ this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //左手发光
  Blockly.JavaScript['light_hand_left'] = function(block) {
    var value_color = block.getFieldValue("input1") || "#ff0000";
    var code = "";
    code += 'await NuwaLight(3 , ' + new Boolean(true) + ' , ' + new Number(255) +  ' , "' + value_color +  '", NsUyWnAc, "'+ this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //右手发光
  Blockly.JavaScript['light_hand_right'] = function(block) {
    var value_color = block.getFieldValue("input1") || "#ff0000";
    var code = "";
    code += 'await NuwaLight(4 , ' + new Boolean(true) + ' , ' + new Number(255) +  ' , "' + value_color +  '", NsUyWnAc, "'+ this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //肚子发光
  Blockly.JavaScript['light_belly'] = function(block) {
    var value_color = block.getFieldValue("input1") || "#ff0000";
    var code = "";
    code += 'await NuwaLight(2 , ' + new Boolean(true) + ' , ' + new Number(255) +  ' , "' + value_color +  '", NsUyWnAc, "'+ this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  Blockly.JavaScript['nuwa_light'] = function(block) {
    var input1 = block.getFieldValue('input1') || 0;
    var input2 = Blockly.JavaScript.valueToCode(block, 'input2', Blockly.JavaScript.ORDER_ATOMIC) || '"#ff0000"';
    var code = "";
    code += 'await NuwaLight('+input1+' , ' + new Boolean(true) + ' , ' + new Number(255) +  ' , ' + input2 +  ', NsUyWnAc, "'+ this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //播放语音
  Blockly.JavaScript['sound_say'] = function(block) {
    var text_content = block.getFieldValue('input1');
    var text_motion = block.getFieldValue('input2') || 0
    var code = "";
    code += 'await NuwaSpeak("' + text_content + '", ' + text_motion + ', NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  Blockly.JavaScript['sound_say2'] = function(block) {
    var value_input1 = Blockly.JavaScript.valueToCode(block, 'input1', Blockly.JavaScript.ORDER_ATOMIC) || "";
    var code = 'await NuwaSpeak(' + value_input1 + ', 0, NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //动物声音
  Blockly.JavaScript['sound_animal'] = function(block) {
    var dropdown_animal = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaSound("' + dropdown_animal + '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //音阶
  Blockly.JavaScript['sound_scale'] = function(block) {
    var dropdown_gamut = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaSound("' + dropdown_gamut + '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //特殊音效
  Blockly.JavaScript['sound_effect'] = function(block) {
    var dropdown_effect = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaSound("' + dropdown_effect + '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };


  //背景音乐
  Blockly.JavaScript['sound_background'] = function(block) {
    var input1 = block.getFieldValue('input1');
    
    var code = "";
    code = code + 'await NuwaBgm("' + input1 + '",false,"' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //日常反应
  Blockly.JavaScript['motion_general'] = function(block) {
    var input1 = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaMotion("'+ input1 +  '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //情绪反应
  Blockly.JavaScript['motion_emotion'] = function(block) {
    var input1 = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaMotion("'+ input1 +  '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //鬼灵精怪
  Blockly.JavaScript['motion_naughty_2'] = function(block) {
    var input1 = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaMotion("'+ input1 +  '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //节日
  Blockly.JavaScript['motion_festival'] = function(block) {
    var input1 = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaMotion("'+ input1 +  '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //脸部表情
  Blockly.JavaScript['motion_face'] = function(block) {
    var input1 = block.getFieldValue('input1');
    
    var code = "";
    code += 'await NuwaFaceImage("'+ input1 +  '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //特殊图片
  Blockly.JavaScript['motion_special_image'] = function(block) {
    var input1 = block.getFieldValue('input1');
    var input2 =  block.getFieldValue('input2') || 3;
    var code = "";
    code +='await NuwaPlayImage("'+ input1 +  '", ' + input2 + ', NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //上传图片
  Blockly.JavaScript['other_function_camera'] = function(block) {
    var input1 = block.getFieldValue("input1") || "mc_picture_default";
    var input2 = block.getFieldValue("input2") || 4;
    var code = 'await NuwaPlayPicture("' + input1 + '", ' + input2 + ', NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //上传影片
  Blockly.JavaScript['other_function_video'] = function(block) {
    var input1 = block.getFieldValue("input1") || "mc_video_default";
    var code = "";
    code += 'await NuwaPlayVideo("'+ input1 +  '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  // youtube
  Blockly.JavaScript['function_video_youtube'] = function(block) {
    var input1 = block.getFieldValue("input1");
    var code = "";
    code += 'await NuwaPlayYoutube("'+ input1 +  '",' + 'NsUyWnAc'+ ',"' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };
  //上传音频/錄音
  Blockly.JavaScript['sound_record'] = function(block) {
    var input1 = block.getFieldValue("input1") || "mc_audio_default";
    var code = "";
    code += 'await NuwaRecordSound("'+ input1 +  '", NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  //四舍五入
  Blockly.JavaScript['nuwa_math_round'] = function(block) {
    var value_number = Blockly.JavaScript.valueToCode(block, 'number', Blockly.JavaScript.ORDER_ATOMIC) || 0;
    var number_precision = block.getFieldValue('precision') || 0;
    number_precision = parseInt(number_precision);
    
    var code = 'Math.round(Math.pow(10,' + number_precision + ') * ' + value_number + ') / Math.pow(10,' + number_precision + ')';
    
    return [code, Blockly.JavaScript.ORDER_ATOMIC];
  };

  //连接MQTT服务器
  Blockly.JavaScript['mqtt_connect'] = function(block) {
    var value_input1 = Blockly.JavaScript.valueToCode(block, 'input1', Blockly.JavaScript.ORDER_ATOMIC) || "";
    var value_input2 = Blockly.JavaScript.valueToCode(block, 'input2', Blockly.JavaScript.ORDER_ATOMIC) || "";
    var value_input3 = Blockly.JavaScript.valueToCode(block, 'input3', Blockly.JavaScript.ORDER_ATOMIC) || "";
    var code = 'await NuwaMqttConnect(' + value_input1 + ', ' + value_input2 + ', ' + value_input3 + ', NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };
  //发送MQTT消息
  Blockly.JavaScript['mqtt_publish'] = function(block) {
    var value_input1 = Blockly.JavaScript.valueToCode(block, 'input1', Blockly.JavaScript.ORDER_ATOMIC);
    var value_input2 = Blockly.JavaScript.valueToCode(block, 'input2', Blockly.JavaScript.ORDER_ATOMIC);
    var code = 'await NuwaMqttPublish(' + value_input1 + ', ' + value_input2 + ', NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };
  // 接收MQTT消息
  Blockly.JavaScript['mqtt_subscribe_message'] = function(block) {
    var value_input1 = Blockly.JavaScript.valueToCode(block, 'input1', Blockly.JavaScript.ORDER_ATOMIC);
    var statements_input2 = Blockly.JavaScript.statementToCode(block, 'input2');
    var code = 'await NuwaMqttSubscribeMessage(' + value_input1 + ', async function(message) {\n' + statements_input2 + '}, NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n'
    return code;
  };
  // 收到的消息message
  Blockly.JavaScript['mqtt_message_text'] = function() {
    return ["message", Blockly.JavaScript.ORDER_NONE];
  };

  //连接
  Blockly.JavaScript['aiot_connect'] = function(block) {
    var iotUrl = config.iotUrl
    var value_input1 = Blockly.JavaScript.valueToCode(block, 'input1', Blockly.JavaScript.ORDER_ATOMIC) || ""; // deviceid
    var value_input2 = Blockly.JavaScript.valueToCode(block, 'input2', Blockly.JavaScript.ORDER_ATOMIC) || ""; // 用户名
    var value_input3 = Blockly.JavaScript.valueToCode(block, 'input3', Blockly.JavaScript.ORDER_ATOMIC) || ""; // 密码
    // var value_input4 = Blockly.JavaScript.valueToCode(block, 'input4', Blockly.JavaScript.ORDER_ATOMIC) || "";
    var statements_name = Blockly.JavaScript.statementToCode(block, 'statements');
    console.log({ iotUrl, statements_name })
    var code = 'await NuwaAiotConnect("'+ iotUrl +'", ' + value_input1 + ', ' + value_input2 + ', ' + value_input3 + ', NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    console.log(code)
    return code;
  };

  // 蜂鸣器 发布

  Blockly.JavaScript['buzzer_iot'] = function(block) {
    var text_input1 = block.getFieldValue('input1');
    var text_input2 = block.getFieldValue('input2');
    console.log('buzzer_iot -> ', { text_input1, text_input2 }, this.id)
    var code = 'await NuwaAiotPublishToBuzzer("' + text_input1 + '", "'+ text_input2 +'", NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  // 繼電器 发布
  Blockly.JavaScript['relay_iot'] = function(block) {
    var dropdown_name = block.getFieldValue('option1');
    console.log('relay_iot -> ', { dropdown_name }, this.id)
    var code = 'await NuwaAiotPublishToRelay("' + dropdown_name + '", NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };

  // 光源感测器 订阅
  Blockly.JavaScript['light_iot'] = function(block) {
    var statements_name = Blockly.JavaScript.statementToCode(block, 'statement');
    console.log('light_iot -> ', { statements_name }, this.id)
 
    var code = 'await NuwaAiotSubscribeFromLight( async function(message) {\n' + statements_name + '}, NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n'
    return code;
  }

  // 光源感测器 订阅
  Blockly.JavaScript['ult_iot'] = function(block) {
    var statements_name = Blockly.JavaScript.statementToCode(block, 'statement');
    console.log('ult_iot -> ', { statements_name }, this.id)
    var code = 'await NuwaAiotSubscribeFromUlt( async function(message) {\n' + statements_name + '}, NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n'
    return code;
  }
  // 环境感测器 订阅
  Blockly.JavaScript['environment_iot'] = function(block) {
    var dropdown_option1 = block.getFieldValue('option1');
    var statements_statement = Blockly.JavaScript.statementToCode(block, 'statement');
    console.log('environment_iot -> ', { dropdown_option1, statements_statement })
    var code = 'await NuwaAiotSubscribeFromEnvironment("' + dropdown_option1 + '", async function(message) {\n' + statements_statement + '}, NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n'
    return code;
  };
  //发送
  Blockly.JavaScript['aiot_publish'] = function(block) {
    var value_input1 = Blockly.JavaScript.valueToCode(block, 'input1', Blockly.JavaScript.ORDER_ATOMIC);
    var value_input2 = Blockly.JavaScript.valueToCode(block, 'input2', Blockly.JavaScript.ORDER_ATOMIC);
    var code = 'await NuwaAiotPublish(' + value_input1 + ', ' + value_input2 + ', NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  };
  // 接收
  Blockly.JavaScript['aiot_subscribe_message'] = function(block) {
    var value_input1 = Blockly.JavaScript.valueToCode(block, 'input1', Blockly.JavaScript.ORDER_ATOMIC);
    var statements_input2 = Blockly.JavaScript.statementToCode(block, 'input2');
    var code = 'await NuwaAiotSubscribeMessage(' + value_input1 + ', async function(message) {\n' + statements_input2 + '}, NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n'
    return code;
  };
  // 收到的消息message
  Blockly.JavaScript['aiot_message_text'] = function() {
    return ["message", Blockly.JavaScript.ORDER_NONE];
  };

  //女娲素材库
  //动态表情
  Blockly.JavaScript['material_lib_role'] = function(block){
    var input1 = block.getFieldValue('input1');
    var input2 = block.getFieldValue('input2');
    var input3 = block.getFieldValue('input3');
    if(!input1 || /^function/.test(input1) || input2 === "nuwa_menu_small" || !input2){
      return "";
    }
    var code = 'await NuwaRole("'+ input1 + "_" + input2 + ".gif" +  '", ' + input3 + ', NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  }
  //图片
  Blockly.JavaScript['material_lib_image'] = function(block){
    var input1 = block.getFieldValue('input1');
    var input2 = block.getFieldValue('input2') || 4;
    if(!input1 || /^function/.test(input1)){
      input1 = "mc_picture_default";
    }
    var code = 'await NuwaPlayPicture("' + input1 + '", ' + input2 + ', NsUyWnAc, "' + this.id + '",NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  }
  //情緒表現（素材庫影片）
  Blockly.JavaScript['material_lib_video'] = function(block){
    var input1 = block.getFieldValue('input1');
    var input2 = block.getFieldValue('input2') || 3;
    if(!input1 || /^function/.test(input1)){
      input1 = "mc_video_default";
    }
    var code = 'await NuwaEmotionVideo("'+ input1 +  '", ' + input2 + ', NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  }
  //声音
  Blockly.JavaScript['material_lib_audio'] = function(block){
    var input1 = block.getFieldValue('input1');
    if(!input1 || /^function/.test(input1)){
      input1 = "mc_audio_default";
    }
    var code = 'await NuwaRecordSound("'+ input1 +  '", NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  }

  //动作
  Blockly.JavaScript['material_lib_motion'] = function(block){
    var input1 = block.getFieldValue('input1');
    if(!input1 || /^function/.test(input1)){
      return "";
    }
    var code = 'await NuwaPlayMotion("'+ input1 +  '", NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  }
  //内容档
  Blockly.JavaScript['material_lib_content'] = function(block){
    var input1 = block.getFieldValue('input1');
    if(!input1 || /^function/.test(input1)){
      return "";
    }
    var code = 'await NuwaPlayContent("'+ input1 +  '", NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  }
  //舞蹈編輯器
  Blockly.JavaScript['material_lib_dance'] = function(block){
    var input1 = block.getFieldValue('input1');
    if(!input1 || /^function/.test(input1)){
      return "";
    }
    var code = 'await NuwaPlayMotion("'+ input1 +  '", NsUyWnAc, "' + this.id + '", NpUaWrAallel_block_id,' + markRunnerId() + ');\n';
    return code;
  }
  //物品辨識
  Blockly.JavaScript['other_function_recognize'] = function() {
    return 'await NuwaRecognizeSome("' + this.id + '", NpUaWrAallel_block_id, ' + markRunnerId() + ');\n';
  };
  //當機器人辨識到物品
  Blockly.JavaScript['start_when_recognize'] = function(block) {
    var text_input1 = block.getFieldValue('input1');
    var code = 'await NuwaWhenRecognize("' + text_input1 + '", "' + this.id + '", ' + markRunnerId() + ');\n';
    return code;
  };
  //等待機器人辨識到物品
  Blockly.JavaScript['control_wait_recognize'] = function(block) {
    var text_input1 = block.getFieldValue('input1');
    var code = 'await NuwaWaitRecognize("' + text_input1 + '", "' + this.id + '", NpUaWrAallel_block_id, ' + markRunnerId() + ');\n';
    return code;
  };
  //物品辨識_如果
  Blockly.JavaScript['control_recognize_if'] = function(block) {
    var text_input1 = block.getFieldValue('input1');
    var text_input2 = block.getFieldValue('input2');
    var statements_input3 = Blockly.JavaScript.statementToCode(block, 'input3');
    var code = 'await NuwaRecognizeIf("' + text_input1 + '", "' + text_input2 + '", async ' + nuwa_func_start + statements_input3 + nuwa_func_end + ', "' + this.id + '", NpUaWrAallel_block_id, ' + markRunnerId() + ');\n';
    return code;
  };
  //物品辨識_如果_否則
  Blockly.JavaScript['control_recognize_ifElse'] = function(block) {
    var text_input1 = block.getFieldValue('input1');
    var text_input2 = block.getFieldValue('input2');
    var statements_input3 = Blockly.JavaScript.statementToCode(block, 'input3');
    var statements_input4 = Blockly.JavaScript.statementToCode(block, 'input4');
    var code = 'await NuwaRecognizeIfElse("' + text_input1 + '", "' + text_input2 + '", async ' + nuwa_func_start + statements_input3 + nuwa_func_end + ', async ' + nuwa_func_start + statements_input4 + nuwa_func_end + ',"' + this.id + '" ,NpUaWrAallel_block_id, ' + markRunnerId() + ');\n';
    return code;
  };
  //没有返回值的函数调整成async函数
  Blockly.JavaScript.procedures_defnoreturn = function(a) {
      var b = Blockly.JavaScript.variableDB_.getName(a.getFieldValue("NAME"), Blockly.Procedures
              .NAME_TYPE),
          c = Blockly.JavaScript.statementToCode(a, "STACK");
      if (Blockly.JavaScript.STATEMENT_PREFIX) {
          var d = a.id.replace(/\$/g, "$$$$");
          c = Blockly.JavaScript.prefixLines(Blockly.JavaScript.STATEMENT_PREFIX.replace(/%1/g, "'" + d + "'"),
              Blockly.JavaScript.INDENT) + c
      }
      Blockly.JavaScript.INFINITE_LOOP_TRAP && (c = Blockly.JavaScript.INFINITE_LOOP_TRAP.replace(/%1/g, "'" +
              a.id + "'") +
          c);
      (d = Blockly.JavaScript.valueToCode(a, "RETURN", Blockly.JavaScript.ORDER_NONE) || "") && (d = Blockly.JavaScript
          .INDENT + "return " + d + ";\n");
      for (var e = [], f = 0; f < a.arguments_.length; f++) e[f] = Blockly.JavaScript.variableDB_.getName(a.arguments_[
          f], Blockly.Variables.NAME_TYPE);
      c = "async function " + b + "(" + e.join(", ") + ") {\n" + c + d + "}";
      c = Blockly.JavaScript.scrub_(a, c);
      Blockly.JavaScript.definitions_["%" + b] = c;
      return null
  };
  //调用没有返回值的函数加上 await
  Blockly.JavaScript.procedures_callnoreturn = function(a) {
      for (var b = "await " + Blockly.JavaScript.variableDB_.getName(a.getFieldValue("NAME"), Blockly.Procedures
              .NAME_TYPE), c = [], d = 0; d < a.arguments_.length; d++) c[d] = Blockly.JavaScript.valueToCode(a,
          "ARG" + d, Blockly.JavaScript.ORDER_COMMA) || "null";
      return b + "(" + c.join(", ") + ");\n"
  };

  const workspaceToCode = Blockly.JavaScript.workspaceToCode;
  Blockly.Generator.prototype.workspaceToCode = function(workSpace){
    let code = workspaceToCode.bind(Blockly.JavaScript)(workSpace);
    code = code.replace(new RegExp(nuwa_func_start + "((\.*)?"+fun_arg_marker+")?", "g"), "function($2){\n")
    .replace(new RegExp(nuwa_func_end, "g"), "}\n");
    code = code.replace(/(\u00A0|\u2028|\u2029|\uFEFF)/gm, "");
    return code;
  }

  //代码构造函数，如果块没有链接开始功能块，不注入块的代码
  if(Blockly.JavaScript.hasNuwaProxy){
    return;
  }
  Blockly.JavaScript = new Proxy(Blockly.JavaScript, {
    get(target, key){
      if(typeof target[key] === "function"){
        return new Proxy(target[key], {
          apply(func,ctx){
            if(!startFuncBlocksType.includes(key) && ctx.type){
              if(hasStartBlock(ctx)){
                let code = Reflect.apply(...arguments);
                return code;
              } else {
                return "";
              }
            } else {
              return Reflect.apply(...arguments);
            }
          }
        })
      } else if(key === "hasNuwaProxy"){
        return true;
      } else {
        return target[key];
      }
    }
  })
}
